const DEFAULT_DOMAIN_ERROR_MESSAGE = 'Enter a valid domain'

export const domainRegExp = new RegExp(/^(?!-)[A-Za-z0-9-]+([\-\.]{1}[a-z0-9]+)*\.[A-Za-z]{2,6}$/)

const validateDomain = (value, message = DEFAULT_DOMAIN_ERROR_MESSAGE) => {
  if (value && !domainRegExp.test(value)) {
    return message
  }

  return null
}

export default validateDomain
